'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import http from 'hub-http/clients/noPortalApiClient';
import { parse } from 'hub-http/helpers/params';
import isValidURL from '../utils/urlValidator';
export default function AuthRedirection(props) {
  useEffect(() => {
    const parsedQuery = parse(props.location.search);
    const referer = parsedQuery.referer || parsedQuery['?referer'];
    const utm_campaign = parsedQuery.utm_campaign || parsedQuery['?utm_campaign'];
    const system = parsedQuery.system || parsedQuery['?system'];
    http.get('https://api.hubspot.com/khoros/integration/auth/staging/jwt/token', {
      query: {
        utm_campaign,
        system
      }
    }).then(result => {
      document.cookie = `Crowdvocate_jwt_token=${result['jwtToken']}; Path=/; Domain=.hubspot.com; Secure`;
      document.cookie = `lithiumSSO%3Amjmao93648=${result['ssoToken']}; Path=/; Domain=.hubspot.com; Secure`;
      document.cookie = `utm_campaign=${utm_campaign}; Path=/; Domain=.hubspot.com; Secure`;
      window.location = isValidURL(referer) ? referer : 'https://community-stage.hubspot.com';
    }).catch(error => {
      if (error.status === 400 && error.responseJSON.message.includes('impersonating')) {
        window.location = '/login-as-error';
      }
    });
  });
  return /*#__PURE__*/_jsx(_Fragment, {});
}